export enum TipoRegraConfrontoEnum {
  Avisar = 1,
  Proibir = 2,
}
